import { IconTextButton, Switcher } from "@smartsuite/react-ui/lib";
import { SolutionColorVariables, TextColorNames } from "@smartsuite/types";
import { useState } from "react";

export interface ActionsProps {
  onPreviewClick: () => void;
  onExportClick: () => void;
  onPrintClick: () => void;
}

export const Actions: React.FC<ActionsProps> = ({
  onPreviewClick,
  onExportClick,
  onPrintClick,
}) => {
  const [isPreviewing, setIsPreviewing] = useState(false);

  return (
    <div className="actions">
      <Switcher
        checked={isPreviewing}
        onChange={(checked) => {
          onPreviewClick();
          setIsPreviewing(checked);
        }}
        label="Preview"
        isFlipped={true}
      />

      <IconTextButton
        textStyle={{ color: TextColorNames.primary }}
        iconStyle={{
          color: SolutionColorVariables.sc1,
          hoverColor: SolutionColorVariables.sc1,
        }}
        iconName="down-arrow-circle"
        className="actions__button"
        onClick={onExportClick}
      >
        Export
      </IconTextButton>

      <IconTextButton
        textStyle={{ color: TextColorNames.primary }}
        iconStyle={{
          color: SolutionColorVariables.sc1,
          hoverColor: SolutionColorVariables.sc1,
        }}
        iconName="print"
        className="actions__button"
        onClick={onPrintClick}
      >
        Print
      </IconTextButton>
    </div>
  );
};
